// import React, { useEffect, useState } from "react";
// import axios from "../../api/axiosInstance";
// import { Link } from "react-router-dom";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, Pagination } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/pagination";
// import mainbg from "../../assets/mainbg.jpg";

// const SuccessStoriesSection = () => {
//   const [stories, setStories] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchStories = async () => {
//       try {
//         const res = await axios.get("/api/success-stories-view/");
//         setStories(res.data);
//       } catch (error) {
//         console.error(error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchStories();
//   }, []);

//   return (
//     <section
//       className="relative max-w-7xl mx-auto px-4 py-10 rounded-lg border overflow-hidden"
//       style={{
//         backgroundImage: `url(${mainbg})`,
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//       }}
//     >
//       {/* Dark overlay for reducing image visibility */}
//       <div className="absolute inset-0 bg-black/50"></div>

//       {/* Content above overlay */}
//       <div className="relative z-10">
//         <div className="text-center mb-6">
//           <h2 className="text-3xl md:text-4xl font-bold text-white drop-shadow-md">
//             Some of <span className="text-orange-400">Happy Marriages!</span>
//           </h2>
//           <p className="text-gray-200 mt-2 max-w-2xl mx-auto">
//             “A happy marriage is not about finding the right person, but creating
//             the right partnership. It’s about two imperfect people who choose each
//             other, every single day.”
//           </p>
//         </div>

//         {loading ? (
//           <div className="text-center text-gray-200">
//             Loading success stories...
//           </div>
//         ) : (
//           <Swiper
//             modules={[Autoplay, Pagination]}
//             spaceBetween={20}
//             autoplay={{ delay: 3000, disableOnInteraction: false }}
//             pagination={{ clickable: true }}
//             slidesPerView={stories.length === 1 ? 1 : undefined}
//             breakpoints={
//               stories.length === 1
//                 ? {}
//                 : {
//                     640: { slidesPerView: 1 },
//                     768: { slidesPerView: 2 },
//                     1024: { slidesPerView: 3 },
//                   }
//             }
//             className="pb-10
//               [&_.swiper-pagination]:flex [&_.swiper-pagination]:justify-center
//               [&_.swiper-pagination]:mt-4 [&_.swiper-pagination]:static
//               [&_.swiper-pagination-bullet]:w-3 [&_.swiper-pagination-bullet]:h-3
//               [&_.swiper-pagination-bullet]:bg-gray-300 [&_.swiper-pagination-bullet]:opacity-100
//               [&_.swiper-pagination-bullet]:mx-1.5 [&_.swiper-pagination-bullet]:rounded-full
//               [&_.swiper-pagination-bullet-active]:bg-orange-500"
//           >
//             {stories.map((story) => (
//               <SwiperSlide key={story.id}>
//                 <div className="bg-white rounded-xl p-4 hover:shadow-lg transition border h-full flex flex-col">
//                   <img
//                     src={
//                       story.photo || require("../../assets/default_image.webp")
//                     }
//                     alt={`${story.bride_name} Weds ${story.groom_name}`}
//                     className="w-full h-48 object-cover rounded-lg mb-3 opacity-90"
//                   />
//                   <h3 className="font-semibold text-lg text-gray-800">
//                     {story.bride_name} weds {story.groom_name}
//                   </h3>
//                   <p className="text-sm text-gray-500 mb-2">
//                     Posted on: {story.marriage_date}
//                   </p>
//                   <p className="text-gray-700 line-clamp-3 mb-2 flex-grow">
//                     {story.story.length > 80
//                       ? story.story.slice(0, 80) + "..."
//                       : story.story}
//                   </p>
//                   <button className="text-orange-600 hover:underline text-sm font-medium self-start">
//                     Read more...
//                   </button>
//                 </div>
//               </SwiperSlide>
//             ))}
//           </Swiper>
//         )}

//         <div className="text-center mt-6">
//           <Link
//             to="success-story"
//             className="inline-flex items-center bg-primary text-decoration-none border border-primary-400 text-orange-400 hover:bg-orange-500 hover:text-white px-5 py-2 rounded-full transition"
//           >
//             View success stories &rarr;
//           </Link>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default SuccessStoriesSection;

import React, { useEffect, useState } from "react";
import axios from "../../api/axiosInstance";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

/* ─── CSS ─────────────────────────────────────────────────────────────────── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;1,600&family=Inter:wght@400;500;600&display=swap');

.jbss {
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: 20px;
  border: 1px solid rgba(201,150,42,0.28);
  background: linear-gradient(160deg, #1A0505 0%, #3D0A0A 55%, #5A1010 100%);
  font-family: 'Inter', sans-serif;
}

/* gold top/bottom bars */
.jbss::before, .jbss::after {
  content: '';
  position: absolute; left: 0; right: 0; height: 3px;
  background: linear-gradient(90deg, transparent, #C9962A 30%, #E8C46A 50%, #C9962A 70%, transparent);
  z-index: 3;
}
.jbss::before { top: 0; }
.jbss::after  { bottom: 0; }

/* dot-grid watermark */
.jbss-dust {
  position: absolute; inset: 0; pointer-events: none; z-index: 0;
  background-image: radial-gradient(circle, rgba(201,150,42,0.09) 1px, transparent 1px);
  background-size: 36px 36px;
}

/* spinning mandala watermark — top right */
.jbss-mandala {
  position: absolute; top: -80px; right: -80px;
  width: 340px; height: 340px;
  opacity: 0.05; pointer-events: none; z-index: 0;
  animation: jbssSpin 90s linear infinite;
}
@keyframes jbssSpin { to { transform: rotate(360deg); } }
@media (prefers-reduced-motion: reduce) { .jbss-mandala { animation: none; } }

/* ── inner ── */
.jbss-inner {
  position: relative; z-index: 1;
  padding: clamp(32px, 5vw, 60px) clamp(16px, 5vw, 48px);
}

/* ── Header ── */
.jbss-hero { text-align: center; margin-bottom: clamp(28px, 4vw, 44px); }

.jbss-om {
  display: block;
  font-size: clamp(34px, 5.5vw, 50px);
  color: #C9962A; font-family: serif; line-height: 1;
  margin-bottom: 12px;
  filter: drop-shadow(0 0 12px rgba(201,150,42,0.35));
}

.jbss-eyebrow {
  display: inline-flex; align-items: center; gap: 10px;
  font-size: clamp(9.5px, 1vw, 11px); font-weight: 600;
  letter-spacing: 2.4px; text-transform: uppercase; color: #C9962A;
  margin-bottom: 12px;
}
.jbss-eline     { width: 26px; height: 1px; background: linear-gradient(90deg, transparent, #C9962A); }
.jbss-eline.r   { background: linear-gradient(90deg, #C9962A, transparent); }

.jbss-title {
  font-family: 'Playfair Display', serif;
  font-size: clamp(24px, 4.5vw, 44px);
  font-weight: 700; color: #FDF6EC; line-height: 1.18;
  margin-bottom: 14px;
}
.jbss-title em { font-style: italic; color: #E8C46A; }

.jbss-quote {
  font-family: 'Playfair Display', serif;
  font-style: italic;
  font-size: clamp(13px, 1.4vw, 15.5px);
  color: rgba(253,246,236,0.68);
  line-height: 1.75;
  max-width: 580px; margin: 0 auto;
}

/* lotus divider */
.jbss-ldiv {
  display: flex; align-items: center; justify-content: center;
  gap: 14px; margin: clamp(18px, 3vw, 28px) 0;
}
.jbss-lline { width: clamp(48px,7vw,100px); height: 1px; background: linear-gradient(90deg,transparent,#C9962A); }
.jbss-lline.r { background: linear-gradient(90deg,#C9962A,transparent); }

/* ── Loading ── */
.jbss-loading {
  text-align: center; padding: 32px;
  font-family: 'Playfair Display', serif;
  font-style: italic; font-size: 15px;
  color: rgba(253,246,236,0.45);
}
.jbss-loading-om {
  font-size: 36px; color: #C9962A; opacity: 0.2;
  font-family: serif; margin-bottom: 10px;
  animation: jbssPulse 2s ease-in-out infinite;
}
@keyframes jbssPulse { 0%,100%{opacity:.2} 50%{opacity:.5} }

/* ── Swiper overrides ── */
.jbss-swiper { padding-bottom: 40px !important; }
.jbss-swiper .swiper-pagination { bottom: 6px !important; }
.jbss-swiper .swiper-pagination-bullet {
  width: 8px; height: 8px;
  background: rgba(201,150,42,0.3) !important;
  opacity: 1 !important; margin: 0 4px !important;
  border-radius: 50%; transition: all .2s;
}
.jbss-swiper .swiper-pagination-bullet-active {
  background: #C9962A !important;
  width: 22px !important; border-radius: 4px !important;
}

/* ── Story card ── */
.jbss-card {
  background: linear-gradient(160deg, #3D0A0A 0%, #5A1010 100%);
  border: 1px solid rgba(201,150,42,0.2);
  border-radius: 16px;
  overflow: hidden;
  display: flex; flex-direction: column;
  height: 100%;
  transition: border-color .2s, transform .2s, box-shadow .2s;
  cursor: pointer;
  position: relative;
}
.jbss-card::before {
  content: '';
  position: absolute; top: 0; left: 0; right: 0; height: 2px;
  background: linear-gradient(90deg, transparent, #C9962A, transparent);
  z-index: 2;
}
.jbss-card:hover {
  border-color: rgba(201,150,42,0.5);
  transform: translateY(-3px);
  box-shadow: 0 14px 40px rgba(0,0,0,0.45);
}

/* image area */
.jbss-img-wrap {
  position: relative; width: 100%; height: clamp(160px, 20vw, 200px);
  overflow: hidden;
}
.jbss-img {
  width: 100%; height: 100%; object-fit: cover;
  transition: transform .35s;
  filter: brightness(0.85);
}
.jbss-card:hover .jbss-img { transform: scale(1.04); }

/* gold overlay gradient on image bottom */
.jbss-img-overlay {
  position: absolute; bottom: 0; left: 0; right: 0; height: 60px;
  background: linear-gradient(to top, #3D0A0A, transparent);
}

/* Om badge on image */
.jbss-img-om {
  position: absolute; top: 10px; right: 10px;
  width: 28px; height: 28px; border-radius: 50%;
  background: rgba(201,150,42,0.85);
  display: flex; align-items: center; justify-content: center;
  font-size: 13px; color: #2C1A0E; font-family: serif;
  box-shadow: 0 2px 8px rgba(0,0,0,0.4);
}

/* card body */
.jbss-body {
  padding: clamp(14px, 2vw, 18px);
  display: flex; flex-direction: column; flex: 1;
}
.jbss-names {
  font-family: 'Playfair Display', serif;
  font-size: clamp(14px, 1.5vw, 16px);
  font-weight: 700; color: #FDF6EC;
  margin-bottom: 4px; line-height: 1.3;
}
.jbss-names em { font-style: italic; color: #E8C46A; }
.jbss-date {
  font-size: clamp(10.5px, 1.1vw, 12px);
  color: rgba(253,246,236,0.48);
  margin-bottom: 10px;
}
.jbss-story-text {
  font-size: clamp(12px, 1.2vw, 13.5px);
  color: rgba(253,246,236,0.68);
  line-height: 1.7;
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.jbss-read-more {
  margin-top: 12px;
  display: inline-flex; align-items: center; gap: 5px;
  font-size: 12px; font-weight: 600;
  color: #C9962A; background: none; border: none; cursor: pointer;
  font-family: 'Inter', sans-serif;
  padding: 0; text-decoration: none;
  transition: color .18s;
}
.jbss-read-more:hover { color: #E8C46A; }

/* ── CTA ── */
.jbss-cta-row {
  text-align: center;
  margin-top: clamp(20px, 3vw, 32px);
}
.jbss-cta {
  display: inline-flex; align-items: center; gap: 8px;
  padding: clamp(9px,1.3vw,12px) clamp(22px,2.8vw,34px);
  background: transparent;
  border: 1.5px solid rgba(201,150,42,0.55);
  border-radius: 28px;
  color: #E8C46A;
  font-size: clamp(13px, 1.4vw, 15px);
  font-weight: 600;
  font-family: 'Playfair Display', serif;
  text-decoration: none;
  transition: background .18s, border-color .18s;
}
.jbss-cta:hover {
  background: rgba(201,150,42,0.12);
  border-color: #C9962A;
}

/* ── Responsive ── */
@media (max-width: 480px) {
  .jbss-mandala { display: none; }
}
@media (max-width: 360px) {
  .jbss { border-radius: 0; border-left: none; border-right: none; }
}
`;

/* ─── Lotus SVG ──────────────────────────────────────────────────────────── */
const Lotus = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 28 28"
    fill="none"
    aria-hidden="true"
  >
    <ellipse cx="14" cy="16" rx="4" ry="9" fill="#C9962A" opacity=".9" />
    <ellipse
      cx="14"
      cy="16"
      rx="4"
      ry="8"
      fill="#C9962A"
      opacity=".85"
      transform="rotate(-30 14 16)"
    />
    <ellipse
      cx="14"
      cy="16"
      rx="4"
      ry="8"
      fill="#C9962A"
      opacity=".85"
      transform="rotate(30 14 16)"
    />
    <ellipse
      cx="14"
      cy="16"
      rx="3.5"
      ry="6"
      fill="#C9962A"
      opacity=".6"
      transform="rotate(-58 14 16)"
    />
    <ellipse
      cx="14"
      cy="16"
      rx="3.5"
      ry="6"
      fill="#C9962A"
      opacity=".6"
      transform="rotate(58 14 16)"
    />
    <ellipse cx="14" cy="24" rx="7" ry="2.5" fill="#C9962A" opacity=".25" />
  </svg>
);

/* ─── Mandala ────────────────────────────────────────────────────────────── */
const Mandala = () => (
  <svg
    className="jbss-mandala"
    viewBox="0 0 400 400"
    fill="none"
    aria-hidden="true"
  >
    {[30, 65, 100, 135, 165, 190].map((r, i) => (
      <circle
        key={i}
        cx="200"
        cy="200"
        r={r}
        stroke="#C9962A"
        strokeWidth={i === 5 ? 1.5 : 0.8}
        strokeDasharray={i === 1 ? "4 4" : undefined}
      />
    ))}
    {Array.from({ length: 16 }, (_, i) => {
      const a = i * 22.5 * (Math.PI / 180);
      const x = 200 + 95 * Math.cos(a),
        y = 200 + 95 * Math.sin(a);
      const cx1 = 200 + 135 * Math.cos(a + 0.18),
        cy1 = 200 + 135 * Math.sin(a + 0.18);
      const cx2 = 200 + 135 * Math.cos(a - 0.18),
        cy2 = 200 + 135 * Math.sin(a - 0.18);
      return (
        <path
          key={i}
          d={`M200,200 Q${cx1},${cy1} ${x},${y} Q${cx2},${cy2} 200,200`}
          stroke="#C9962A"
          strokeWidth=".7"
        />
      );
    })}
    {Array.from({ length: 12 }, (_, i) => {
      const a = i * 30 * (Math.PI / 180);
      return (
        <line
          key={i}
          x1={200 + 22 * Math.cos(a)}
          y1={200 + 22 * Math.sin(a)}
          x2={200 + 65 * Math.cos(a)}
          y2={200 + 65 * Math.sin(a)}
          stroke="#C9962A"
          strokeWidth=".8"
        />
      );
    })}
    <circle cx="200" cy="200" r="22" stroke="#C9962A" strokeWidth="1" />
  </svg>
);

/* ─── Component ───────────────────────────────────────────────────────────── */
const SuccessStoriesSection = () => {
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);

  /* inject CSS */
  useEffect(() => {
    const id = "jbss-styles";
    if (!document.getElementById(id)) {
      const el = document.createElement("style");
      el.id = id;
      el.textContent = CSS;
      document.head.appendChild(el);
    }
    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, []);

  useEffect(() => {
    const fetchStories = async () => {
      try {
        const res = await axios.get("/api/success-stories-view/");
        setStories(res.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchStories();
  }, []);

  const slidesBreakpoints = (count) =>
    count === 1
      ? {}
      : {
          640: { slidesPerView: 1 },
          768: { slidesPerView: 2, spaceBetween: 18 },
          1024: { slidesPerView: 3, spaceBetween: 20 },
        };

  return (
    <section className="jbss" aria-labelledby="jbss-title">
      <div className="jbss-dust" aria-hidden="true" />
      <Mandala />

      <div className="jbss-inner">
        {/* ── Hero ── */}
        <header className="jbss-hero">
          <span className="jbss-om" aria-label="Om">
            ꣽ
          </span>

          <div className="jbss-eyebrow" aria-hidden="true">
            <span className="jbss-eline" />
            Jain Var Vadhu · Eternal Unions
            <span className="jbss-eline r" />
          </div>

          <h2 className="jbss-title" id="jbss-title">
            Sacred <em>Happy Marriages!</em>
          </h2>

          <p className="jbss-quote">
            "A happy marriage is not just the union of two people — it is the
            alignment of two spirits walking the path of Dharma together, every
            single day."
          </p>
        </header>

        {/* lotus divider */}
        <div className="jbss-ldiv" aria-hidden="true">
          <div className="jbss-lline" />
          <Lotus />
          <div className="jbss-lline r" />
        </div>

        {/* ── Loading ── */}
        {loading ? (
          <div className="jbss-loading">
            <div className="jbss-loading-om">ॐ</div>
            Loading sacred stories…
          </div>
        ) : (
          /* ── Swiper ── */
          <Swiper
            className="jbss-swiper"
            modules={[Autoplay, Pagination]}
            spaceBetween={16}
            autoplay={{ delay: 3200, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            slidesPerView={stories.length === 1 ? 1 : undefined}
            breakpoints={slidesBreakpoints(stories.length)}
          >
            {stories.map((story) => (
              <SwiperSlide key={story.id} style={{ height: "auto" }}>
                <div className="jbss-card">
                  {/* Image */}
                  <div className="jbss-img-wrap">
                    <img
                      src={
                        story.photo ||
                        require("../../assets/default_image.webp")
                      }
                      alt={`${story.bride_name} weds ${story.groom_name}`}
                      className="jbss-img"
                    />
                    <div className="jbss-img-overlay" aria-hidden="true" />
                    <div className="jbss-img-om" aria-hidden="true">
                      ꣽ
                    </div>
                  </div>

                  {/* Body */}
                  <div className="jbss-body">
                    <h3 className="jbss-names">
                      {story.bride_name} <em>weds</em> {story.groom_name}
                    </h3>
                    <p className="jbss-date">🪷 {story.marriage_date}</p>
                    <p className="jbss-story-text">
                      {story.story.length > 100
                        ? story.story.slice(0, 100) + "…"
                        : story.story}
                    </p>
                    <Link
                      to={`/success-story/${story.id}`}
                      className="jbss-read-more"
                    >
                      Read their journey →
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}

        {/* ── CTA ── */}
        <div className="jbss-cta-row">
          <Link to="success-story" className="jbss-cta">
            🪷 View All Sacred Unions →
          </Link>
        </div>
      </div>
    </section>
  );
};

export default SuccessStoriesSection;
